import { useEffect, useState } from 'react';
import { Switch } from 'src/components/ui/switch';
import { clsx } from 'clsx';

export const SwitchWithLoading = ({
  isLoading = false,
  disabled = false,
  defaultChecked,
  onCheckedChange = (_val: boolean) => {},
}: {
  isLoading?: boolean;
  disabled?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (val: boolean) => void;
}) => {
  const [checkedState, setCheckedState] = useState(defaultChecked);
  const [isChanging, setIsChanging] = useState(false);

  const handleChange = (val: boolean) => {
    setCheckedState(val);
    onCheckedChange(val);
    setIsChanging(true);
  };

  useEffect(() => {
    if (!isLoading) {
      setIsChanging(false);
    }
  }, [isLoading]);

  return (
    <Switch
      disabled={disabled}
      checked={checkedState}
      defaultChecked={defaultChecked}
      className={clsx(isChanging && 'blur-sm animate-pulse pointer-events-none')}
      onCheckedChange={handleChange}
    />
  );
};
